// Car brands we have CONFIRMED working with Saving Mode (via Smartcar).
// This is not an exhaustive list of what's possible: brands not listed here may still work,
// we just can't guarantee it up front.
// "beta" = the brand works for many customers, but we see connection issues on some accounts.
// Saving Mode always runs through all three parts: charger + car + the enkel app.
// Source: our app/partner team, September 2026. Whether a car can connect depends on model,
// year, equipment and the manufacturer's own API — it can change without notice.

export const SUPPORTED_BRANDS = [
  'Alfa Romeo', 'Audi', 'BMW', 'BYD', 'Citroën', 'CUPRA', 'Dacia', 'DS', 'Fiat', 'Ford',
  'Hyundai', 'Jaguar', 'Jeep', 'Kia', 'Land Rover', 'Mazda', 'Mercedes-Benz', 'MG', 'MINI',
  'Nissan', 'Opel', 'Peugeot', 'Polestar', 'Porsche', 'Renault', 'Škoda', 'Tesla',
  'Vauxhall', 'Volkswagen', 'Volvo',
];

// Brands currently in beta (known connection issues on some accounts)
export const BETA_BRANDS = ['BMW', 'Mazda', 'Renault', 'Škoda', 'Volkswagen'];

// Every chooser includes both confirmed and beta brands, without duplicates.
export const ALL_SUPPORTED_BRANDS = [...new Set([...SUPPORTED_BRANDS, ...BETA_BRANDS])].sort((a, b) => a.localeCompare(b, 'da'));

export const isBeta = (brand) => BETA_BRANDS.includes(brand);

export const STABLE_BRANDS = SUPPORTED_BRANDS.filter((b) => !isBeta(b));

// Last time the list was reviewed with our app team
export const BRAND_LIST_UPDATED = { da: 'september 2026', en: 'September 2026' };